import { createPaymentIntents, confirmPaymentIntents, completePaymentIntents } from '@/api/payments.js';

// eslint-disable-next-line
export const createPaymentIntent = params => {
  params = _.get(params, 'paymentMethodType', null) === 'saved_card' ? { ...params, paymentMethodType: 'card' } : params;
  return createPaymentIntents(params);
};

// eslint-disable-next-line
export const confirmPaymentIntent = (id, params) => {
  return confirmPaymentIntents(id, params);
};

// eslint-disable-next-line
export const completePaymentIntent = (orderId, params) => {
  return completePaymentIntents(orderId, params);
};
